<h4
  id="{{ baseId }}-other-information-subtitle"
  translate
>Other Information</h4>
<section class="flex-row-generic" [formGroup]="form">

  <!-- Gender FindControl -->
  <div class="form-group flex-item-four-columns">
    <label for="{{ baseId }}-current-sex" translate>Current Sex</label>
    <ap-findcontrol
      id="{{ baseId }}-current-sex"
      controlName="genderUid"
      findControlDisplayName="Find Gender"
      [baseId]="baseId"
      [form]="form"
      [apFormGroup]="form"
      [formGroupSubmitted]="isSubmitted"
      [singleSelect]="true"
      [findControlId]="FindControlIdService.ListGender"
      [selectedPks]="genderUidControl.value"
      (dirty)="genderUidControl.markAsDirty()"
    >
    </ap-findcontrol>
  </div>
  <!-- Gender FindControl -->

  <!-- Birth Gender FindControl -->
  <div class="form-group flex-item-four-columns">
    <label for="{{ baseId }}-birth-sex" translate>Birth Sex</label>
    <ap-findcontrol
      id="{{ baseId }}-birth-sex"
      controlName="birthGenderUid"
      findControlDisplayName="Find Gender"
      [baseId]="baseId"
      [form]="form"
      [apFormGroup]="form"
      [formGroupSubmitted]="isSubmitted"
      [singleSelect]="true"
      [findControlId]="FindControlIdService.ListGender"
      [selectedPks]="birthGenderUidControl.value"
      (dirty)="birthGenderUidControl.markAsDirty()"
    >
    </ap-findcontrol>
  </div>
  <!-- Birth Gender FindControl -->

  <!-- Gender Identity FindControl -->
  <div class="form-group flex-item-four-columns">
    <label for="{{ baseId }}-gender-identity" translate>Gender Identity</label>
    <ap-findcontrol
      id="{{ baseId }}-gender-identity"
      controlName="genderIdentityUid"
      findControlDisplayName="Find Gender Identity"
      [baseId]="baseId"
      [form]="form"
      [apFormGroup]="form"
      [formGroupSubmitted]="isSubmitted"
      [singleSelect]="true"
      [findControlId]="FindControlIdService.ListGenderIdentity"
      [selectedPks]="genderIdentityUidControl.value"
      (dirty)="genderIdentityUidControl.markAsDirty()"
    >
    </ap-findcontrol>
  </div>
  <!-- Gender Identity FindControl -->

  <!-- Sexual Orientation FindControl -->
  <div class="form-group flex-item-four-columns">
    <label for="{{ baseId }}-sexual-orientation" translate>Sexual Orientation</label>
    <ap-findcontrol
      id="{{ baseId }}-sexual-orientation"
      controlName="sexualOrientationUid"
      findControlDisplayName="Find Sexual Orientation"
      [baseId]="baseId"
      [form]="form"
      [apFormGroup]="form"
      [formGroupSubmitted]="isSubmitted"
      [singleSelect]="true"
      [findControlId]="FindControlIdService.ListSexualOrientation"
      [selectedPks]="sexualOrientationUidControl.value"
      (dirty)="sexualOrientationUidControl.markAsDirty()"
    >
    </ap-findcontrol>
  </div>
  <!-- Sexual Orientation FindControl -->

  <!-- Birth Date Control -->
  <div class="form-group flex-item-four-columns">
    <ap-date-picker
      [baseId]="baseId"
      [maxDate]="birthMaxDate"
      formControlName="birthDate"
      labelName="Birth Date">
    </ap-date-picker>
  </div>
  <!-- Birth Date Control -->

  <!-- Death Date Control -->
  <div class="form-group flex-item-four-columns">
    <ap-date-picker
      [baseId]="baseId"
      [minDate]="deathMinDate"
      [maxDate]="deathMaxDate"
      formControlName="deathDate"
      labelName="Death Date">
    </ap-date-picker>
  </div>
  <!-- Death Date Control -->

  <!-- Marital Status FindControl -->
  <div class="form-group flex-item-four-columns">
    <label for="{{ baseId }}-marital-status" translate>Marital Status</label>
    <ap-findcontrol
      id="{{ baseId }}-marital-status"
      controlName="maritalStatusUid"
      findControlDisplayName="Find Marital Status"
      [baseId]="baseId"
      [form]="form"
      [apFormGroup]="form"
      [formGroupSubmitted]="isSubmitted"
      [singleSelect]="true"
      [findControlId]="FindControlIdService.ListMaritalStatus"
      [selectedPks]="maritalStatusUidControl.value"
      (dirty)="maritalStatusUidControl.markAsDirty()"
    >
    </ap-findcontrol>
  </div>
  <!-- Marital Status FindControl -->

  <!-- Race FindControl -->
  <div class="form-group flex-item-four-columns">
    <label for="{{ baseId }}-race" translate>Race</label>
    <ap-findcontrol
      id="{{ baseId }}-race"
      controlName="raceUids"
      findControlDisplayName="Find Race"
      [baseId]="baseId"
      [form]="form"
      [apFormGroup]="form"
      [formGroupSubmitted]="isSubmitted"
      [singleSelect]="false"
      [findControlId]="FindControlIdService.ListRace"
      [selectedPks]="raceUidsControl.value"
      (dirty)="raceUidsControl.markAsDirty()"
    >
    </ap-findcontrol>
  </div>
  <!-- Race FindControl -->

  <!-- Ethnicity FindControl -->
  <div class="form-group flex-item-four-columns">
    <label for="{{ baseId }}-ethnicity" translate>Ethnicity</label>
    <ap-findcontrol
      id="{{ baseId }}-ethnicity"
      controlName="ethnicityUids"
      findControlDisplayName="Find Ethnicity"
      [baseId]="baseId"
      [form]="form"
      [apFormGroup]="form"
      [formGroupSubmitted]="isSubmitted"
      [singleSelect]="false"
      [findControlId]="FindControlIdService.ListEthnicity"
      [selectedPks]="ethnicityUidsControl.value"
      (dirty)="ethnicityUidsControl.markAsDirty()"
    >
    </ap-findcontrol>
  </div>
  <!-- Ethnicity FindControl -->

  <!-- Preferred Language FindControl -->
  <div class="form-group flex-item-four-columns">
    <label for="{{ baseId }}-preferred-language" translate>Preferred Language</label>
    <ap-findcontrol
      id="{{ baseId }}-preferred-language"
      controlName="preferredLanguageUid"
      findControlDisplayName="Find Language"
      [baseId]="baseId"
      [form]="form"
      [apFormGroup]="form"
      [formGroupSubmitted]="isSubmitted"
      [singleSelect]="true"
      [findControlId]="FindControlIdService.ListLanguage"
      [selectedPks]="preferredLanguageUidControl.value"
      (dirty)="preferredLanguageUidControl.markAsDirty()"
    >
    </ap-findcontrol>
  </div>
  <!-- Preferred Language FindControl -->

  <!-- Translator Required Checkbox -->
  <div class="checkbox-group flex-item-four-columns modal-checkboxes">
    <mat-checkbox
      id="{{ baseId }}-translator-required"
      formControlName="translatorRequired"
      translate
    >
      Translator Required
    </mat-checkbox>
  </div>
  <!-- Translator Required Checkbox -->

  <!-- Dominant Hand FindControl -->
  <div class="form-group flex-item-four-columns">
    <label for="{{ baseId }}-dominant-hand" translate>Dominant Hand</label>
    <ap-findcontrol
      id="{{ baseId }}-dominant-hand"
      controlName="dominantHandUid"
      findControlDisplayName="Find Dominant Hand"
      [baseId]="baseId"
      [form]="form"
      [apFormGroup]="form"
      [formGroupSubmitted]="isSubmitted"
      [singleSelect]="true"
      [findControlId]="FindControlIdService.ListDominantHand"
      [selectedPks]="dominantHandUidControl.value"
      (dirty)="dominantHandUidControl.markAsDirty()"
    >
    </ap-findcontrol>
  </div>
  <!-- Dominant Hand FindControl -->

  <!-- Social Security Number Control -->
  <div class="form-group flex-item-four-columns">
    <label
      for="{{ baseId }}-social-security-number"
      translate
    >SSN</label>
    <input
      id="{{ baseId }}-social-security-number"
      type="text"
      class="form-control"
      [ngClass]="{ error: showErrors(socialSecurityNumberControl, isSubmitted), 'required': isRequired(socialSecurityNumberControl) }"
      [maxlength]="fcListValidation.validations.SocialSecurityNumber.MaxLength"
      [specialCharacters]="['-']"
      [dropSpecialCharacters]="false"
      mask="000-00-0000"
      formControlName="socialSecurityNumber"
    />
    <div
      *ngIf="showErrors(socialSecurityNumberControl, isSubmitted)"
      id="{{ baseId }}-warning-text-social-security-number"
      class="incorrect-input"
      translate
    >
      {{ socialSecurityNumberControl.errors | fcListValidation : 'Social Security number' : { pattern: 'Please enter a nine-digit Social Security Number' }  }}
    </div>
  </div>
  <!-- Social Security Number Control -->

  <!-- Driver's License # Control -->
  <div class="form-group flex-item-four-columns">
    <label
      for="{{ baseId }}-drivers-license-number"
      translate
    >Driver's License #</label>
    <input
      id="{{ baseId }}-drivers-license-number"
      class="form-control"
      [ngClass]="{ error: showErrors(driversLicenseNumberControl, isSubmitted), 'required': isRequired(driversLicenseNumberControl) }"
      type="text"
      [maxlength]="fcListValidation.validations.DriverLicenseNumber.MaxLength"
      formControlName="driversLicenseNumber"
    />
    <div
      *ngIf="showErrors(driversLicenseNumberControl, isSubmitted)"
      id="{{ baseId }}-warning-text-drivers-license-number"
      class="incorrect-input"
      translate
    >
      {{ driversLicenseNumberControl.errors | fcListValidation : 'Driver\'s License #' }}
    </div>
  </div>
  <!-- Driver's License # Control -->

  <!-- Driver's License State Control -->
  <div class="form-group flex-item-four-columns">
    <label
      for="{{ baseId }}-drivers-license-state"
      translate
    >Driver's License State</label>
    <input
      id="{{ baseId }}-drivers-license-state"
      class="form-control"
      [ngClass]="{ error: showErrors(driversLicenseStateControl, isSubmitted), 'required': isRequired(driversLicenseStateControl) }"
      type="text"
      [maxlength]="fcListValidation.validations.DriverLicenseState.MaxLength"
      formControlName="driversLicenseState"
    />
    <div
      *ngIf="showErrors(driversLicenseStateControl, isSubmitted)"
      id="{{ baseId }}-warning-text-drivers-license-state"
      class="incorrect-input"
      translate
    >
      {{ driversLicenseStateControl.errors | fcListValidation : 'Driver\'s License State' }}
    </div>
  </div>
  <!-- Driver's License State Control -->

</section>
